import React from "react";
import {AnimatePresence, motion} from "motion/react";
import IntroGrid from "@/components/IntroGrid";
import {useNav} from "@/hooks/useNav";

interface GridLayerProps extends React.HTMLAttributes<HTMLDivElement> {
}

const GridLayer: React.FC<GridLayerProps> = ({className, ...props}) => {
    return (
        <div {...props}
             style={{position: 'absolute', inset: 0, width: '100vw', height: '100vh'}}>
            <IntroGrid id="intro_grid"/>
        </div>
    );
};

export default GridLayer;
